import { render, staticRenderFns } from "./ActivateForm.vue?vue&type=template&id=c01a36c2"
import script from "./ActivateForm.vue?vue&type=script&lang=js"
export * from "./ActivateForm.vue?vue&type=script&lang=js"
import style0 from "./ActivateForm.vue?vue&type=style&index=0&id=c01a36c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports